import { Typography } from 'antd';
import { FC } from 'react';

import * as Styled from './valuation-method-option.style';

const { Text } = Typography;

interface ValuationMethodOptionProps {
  title: string;
  description: string;
}

const ValuationMethodOption: FC<ValuationMethodOptionProps> = ({
  title,
  description,
}) => (
  <Styled.SelectOption>
    <Text strong>{title}</Text>
    <Text type="secondary">{description}</Text>
  </Styled.SelectOption>
);

export { ValuationMethodOption };
